import { createIcon } from '../createIcon'

export const LinkedinIcon = createIcon(
  <path d="M3.307 2.005c0 .788-.589 1.427-1.557 1.427-.911 0-1.5-.639-1.5-1.427S.858.58 1.788.58c.931 0 1.5.619 1.519 1.426ZM.327 13.733V4.557h2.885v9.176H.326ZM4.939 7.484c0-1.144-.038-2.1-.076-2.927h2.506l.134 1.276h.057c.38-.6 1.31-1.482 2.867-1.482 1.9 0 3.323 1.258 3.323 3.96v5.423h-2.886V8.649c0-1.183-.418-1.99-1.462-1.99-.798 0-1.272.544-1.481 1.07-.076.187-.095.45-.095.712v5.291H4.94V7.484l-.001.001Z" />,
  'LinkedinIcon',
  '0 0 14 14',
)
